import { useEffect } from "react";
import Lenis from "lenis";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Signal } from "@/components/Signal";
import { DreamMagnet } from "@/components/DreamMagnet";
import { Manifesto } from "@/components/Manifesto";
import { Positioning } from "@/components/Positioning";
import { Pricing } from "@/components/Pricing";
import { SocialProof } from "@/components/SocialProof";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        // Expose the instance so nav/CTAs can drive smooth scrolling reliably
        window.__lenis = lenis;

        // If arriving with a hash (e.g. from /start), scroll to that section
        if (window.location.hash) {
            const id = window.location.hash;
            setTimeout(() => {
                const el = document.querySelector(id);
                if (el) lenis.scrollTo(el, { offset: -72 });
            }, 600);
        }

        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            if (window.__lenis === lenis) window.__lenis = null;
        };
    }, []);

    return (
        <div className="App grain">
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Signal />
                <Manifesto />
                <Positioning />
                <DreamMagnet />
                <Pricing />
                <About />
                <SocialProof />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
